import { Navigate, Outlet } from "react-router-dom";
import { usePortal } from "@app/portal-sdk";
import { LoadingScreen } from "../components/LoadingScreen";

/** Layout guard for /admin/*: only bkdp-admin users get through. */
export const RequireAdmin = () => {
  const { loading, isBkdpAdmin } = usePortal();
  if (loading) {
    return <LoadingScreen />;
  }
  if (!isBkdpAdmin) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};
